import { styled } from '@mui/system';
import COLORS from '../../../../theme/Colors';
import FONTS_FAMILY from '../../../../theme/FontsFamily';

export const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
});

export const ButtonsContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '32px',
    paddingTop: '24px',
    borderTop: '1px solid #E1E9EC'
});

export const ButtonContainer = styled('div')({
    minWidth: '140px',
});

export const DisclaimerButtonCotainer = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px'
});

export const FinalStepContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignSelf: 'center',
    alignItems: 'center',
    padding: '40px 20px',
    backgroundColor: '#F8FAFC',
    borderRadius: '20px',
    border: '1px dashed #CFDCE0',
    width: '100%',
    boxSizing: 'border-box'
});

export const DisclaimerSubTitle = styled("p")({
    color: COLORS.secondary,
    textAlign: "center",
    marginBottom: "16px",
    alignSelf: 'center',
    fontFamily: FONTS_FAMILY.regular.body,
    fontSize: "15px",
    lineHeight: 1.6,
    maxWidth: "600px"
});

export const DisclaimerTitle = styled("h3")({
    color: COLORS.secondary,
    margin: "0 0 12px 0",
    textAlign: "center",
    fontSize: "26px",
    fontWeight: "800",
    fontFamily: "Merriweather, serif"
});